module.exports = __webpack_public_path__ + "static/media/social-icon-linkedin-orange.48fe1918.svg";